// API hata detayını güvenli düz metne çevirir (FastAPI 422 detail dizisi dahil).
// Doğrudan toast.error(detail) çağrısı detail nesne/dizi ise React render hatasına (beyaz ekran) yol açar.
export const errText = (e, fallback = "İşlem başarısız") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || x?.message || JSON.stringify(x)).join(" · ");
  if (typeof d === "object") return d.message || d.msg || JSON.stringify(d);
  return String(d);
};
